import { render, staticRenderFns } from "./commentPopover.vue?vue&type=template&id=6140125c&scoped=true"
import script from "./commentPopover.vue?vue&type=script&lang=js"
export * from "./commentPopover.vue?vue&type=script&lang=js"
import style0 from "./commentPopover.vue?vue&type=style&index=0&id=6140125c&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6140125c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/data/workspace/KCC_AUDIT_PROD_Frontend/node_modules/vue-loader/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6140125c')) {
      api.createRecord('6140125c', component.options)
    } else {
      api.reload('6140125c', component.options)
    }
    module.hot.accept("./commentPopover.vue?vue&type=template&id=6140125c&scoped=true", function () {
      api.rerender('6140125c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/client-view/exchange/ITA/components/commentPopover.vue"
export default component.exports